import { api } from "@service/api";
import { useEffect, useState } from "react";
import { Close } from "@components/buttons/close";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { Button } from "@components/buttons/button";
import { TextAreaQuill } from "@components/forms/textarea-quill/textarea-quill";

interface IProps {
  campaignName: string;
  raffleType: number;
  isOpen: boolean;
  onClose: (campaignCode?: string) => void;
}

export function ModalRaffleCampaignDescription({
  campaignName,
  raffleType,
  isOpen,
  onClose,
}: IProps) {
  // --- Default Variables --- //
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // --- Importants Use States --- //
  const [description, setDescription] = useState<string | undefined>(undefined);

  function handleClose() {
    // --- Fix Empty  TextArea result in '<p><br></p>' as Default --- //
    const tmpDescr = description === `<p><br></p>` ? undefined : description;
    setTimeout(() => onClose(tmpDescr), 300);
  }

  return (
    <>
      <div
        className={`modal fade ${isOpen ? "show" : ""}`}
        style={{ display: isOpen ? "block" : "none" }}
        aria-labelledby="staticBackdropLabel"
        aria-hidden={!isOpen}
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title fw-bold" id="contentModallLabel">
                Descrição da Campanha
              </h5>
              <Close onPress={handleClose} />
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              {/* Text Area */}
              <div className="col-md-12 mb-4">
                <TextAreaQuill
                  text={description}
                  onChange={(content) => {
                    setDescription(content);
                  }}
                />
              </div>

              {/* The main button */}
              <div className="col-md-12 mb-2 col-12 text-end">
                <Button
                  onClick={handleClose}
                  children={"Salvar"}
                  className={`btn btn-secondary py-2 px-5`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
